import * as React from 'react';
 
const LogoSection = () => {
  return (
    <>
      <img alt="logo" src={"./images/logo.svg"} />
    </>
  );
};
export default LogoSection;
